<script setup>
import { ref, watch, onMounted } from 'vue'
import { useLayout } from '@/layout/composables/layout'
import { embedDashboard } from '@superset-ui/embedded-sdk'

const { isDarkTheme } = useLayout()
const chartContainer = ref(null)

const SUPSET_EMBEDDED_ID = '923776c8-49c3-4e37-b9b2-dfd7f85b56fa'

// Fetch guest token from Spring Boot API
const fetchGuestToken = async () => {
  console.log('Fetching guest token...')

  const response = await fetch('http://localhost:8082/superset/guest-token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ dashboardId: SUPSET_EMBEDDED_ID })
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch guest token: ${response.status}`)
  }

  const data = await response.json()
  console.log('Token received:', data)

  return data.token
}

onMounted(async () => {
  if (!chartContainer.value) return

  try {
    await embedDashboard({
      id: SUPSET_EMBEDDED_ID,
      supersetDomain: 'https://superset.aqviser.com',
      mountPoint: chartContainer.value,
      fetchGuestToken,
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: true,
        hideTab: true,
        // guest-safe mode: readonly
        readOnly: true
      }
    })
  } catch (err) {
    console.error('Embed error:', err)
  }
})

const lineOptions = ref(null)

const applyLightTheme = () => {
  lineOptions.value = {
    plugins: { legend: { labels: { color: '#495057' } } },
    scales: {
      x: { ticks: { color: '#495057' }, grid: { color: '#ebedef' } },
      y: { ticks: { color: '#495057' }, grid: { color: '#ebedef' } }
    }
  }
}

const applyDarkTheme = () => {
  lineOptions.value = {
    plugins: { legend: { labels: { color: '#ebedef' } } },
    scales: {
      x: { ticks: { color: '#ebedef' }, grid: { color: 'rgba(160, 167, 181, .3)' } },
      y: { ticks: { color: '#ebedef' }, grid: { color: 'rgba(160, 167, 181, .3)' } }
    }
  }
}

watch(isDarkTheme, val => {
  val ? applyDarkTheme() : applyLightTheme()
}, { immediate: true })
</script>

<template>
  <div class="grid">
    <div class="col-12 lg:col-6 xl:col-6">
      <div class="card mb-0">
        <div class="mb-3">
          <span class="block text-500 font-medium mb-2">
            Superset Chart
          </span>
        </div>

        <div ref="chartContainer" class="chart-wrapper"></div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.chart-wrapper {
  width: 100%;
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
}
</style>